import z from 'zod';

export const criteriaGroupSchema = z.object({
  name: z.string().trim().nonempty(),
  criteria_transformed: z.array(z.object({ id: z.string().uuid() })).min(1),
});
